<template xmlns:v-clipboard="http://www.w3.org/1999/xhtml">
  <div class="zhuce_box">
    <div class="title">
        <div class="title_text">注册邀请</div>
    </div>
    <div class="zhuce_core">
        <div>邀请码：{{yaoqingma}}</div>
        <div class="zhuce-core-box">
            <div><img src="../assets/zhuce/miaotit.png" alt=""></div>
            <div class="phone_box">
            <div class="phone_box_t">
                <input v-model="phoneNum" type="number" placeholder="请输入您的手机号">
            </div>
            <div class="phone_box_c">
              <div class="phone_box_t">
                <input v-model="verifyNum" type="number" placeholder="请输入您获取的验证码">
              </div>
              <div class="phone_box_r" v-show="timeshow" @click="getVerify()">获取验证码</div>
              <div class="phone_box_r phone_box_n" v-show="!timeshow" @click="getVerifyss()">{{time}}</div>
            </div>
            <div class="phone_box_t">
              <input v-model="password" type="text" placeholder="请设置新密码">
            </div>
          </div>
          <div class="zhuce" @click="sign()">
            <div>注册完成并下载APP</div>
          </div>
        </div>
    </div>
  </div>
</template>
<script>
import { Toast } from 'mint-ui'
import axios from "axios";
import "swiper/dist/css/swiper.css";
import qs from 'qs'
import { swiper, swiperSlide } from "vue-awesome-swiper";
export default {
  name: "miaoshengZhuce",
  data() {
    return {
      phoneNum: '',//手机号
      verifyNum: '',//验证码
      password: '',//密码
      code: '',
      uas: '',
      bizId: '',
      codeVersion: '',
      yaoqingma: '',
      time: 60,
      timeshow: true,
      downloadUrl:'',
      openUrl:''

    };
  },
  created() {
    axios.defaults.headers = {
      'Content-type': 'application/x-www-form-urlencoded'
    }
    axios.defaults.transformRequest = (data) => {
      data = qs.stringify(data)
      return data
    }
    this.code = this.GLOBAL.getQueryString('code')
    this.codeVersion = this.GLOBAL.getQueryString('codeVersion')
    // this.code = 'MjQzXzIyMzI4MQ%3D%3D'
    // this.codeVersion = "340"
    let promiseArr = {};
        let cancel = {};
        axios.interceptors.request.use(
          config => {
            // 发起请求时，取消掉当前正在进行的相同请求
            if (promiseArr[config.url]) {
              // promiseArr[config.url]('操作取消')
              promiseArr[config.url] = cancel
            } else {
              promiseArr[config.url] = cancel
            }
            const token = this.token
            if (token) {
              config.headers.token = token
            }
            return config
          },
          err => {
            return Promise.reject(err)
          }
        )
        // this.uas = window.navigator.userAgent.toLowerCase();
        // if (this.uas.match(/MicroMessenger/i) == "micromessenger"){
        //   console.log("微信浏览器")
        //   this.getstyle()
        // }else{
        //   console.log("不是微信浏览器")
        //   // this.nowinxin()
        // }

  },
  mounted() {
    this.getstyle()
    // this.timeFn()
    axios.get(this.GLOBAL.apiUrl + '/api/w1/share/download/?code=' + this.GLOBAL.getQueryString('code')).then((res) => {
      if (res.data.code === 0) {
        // this.datas = res.data.data
        // this.invitation_img = res.data.data.invitation_img
        // this.newImgUrl = res.data.data.invitation_img[0]
        // this.code = res.data.data.invite_code
        const downloadType = res.data.data.download_type
        const deviceType = this.deviceType()
        if (downloadType === 'two-in-one') {
          this.downloadUrl = res.data.data.two_in_one
          if (deviceType === 'ios') {
            this.openUrl = 'uxiang' + res.data.data.bizId + '://'
          } else {
            this.openUrl = 'app://' + res.data.data.shareInfo.APP_DOWNLOAD_BAO_ANDROID + '/openapp'
        
          }
        } else {
          if (deviceType === 'ios') {
            this.downloadUrl = res.data.data.ios
            this.openUrl = 'uxiang' + res.data.data.bizId + '://'
          } else {
            this.downloadUrl = res.data.data.android
            this.openUrl = 'app://' + res.data.data.shareInfo.APP_DOWNLOAD_BAO_ANDROID + '/openapp'
          }
        }
        document.title = res.data.data.title
      }
    })
  },
  methods: {
    getstyle(){
      axios.get(this.GLOBAL.apiUrlNative + "/api/w1/share/download?code=" + this.code).then(res => {
        console.log(1)
        this.bizId = res.data.data.bizId;
        this.url = res.data.data.oauthUrl;
        this.yaoqingma = res.data.data.invite_code
        // this.wixin ()
      });
    },
    // 注册
   sign () {
      var regexs = /^[1][0-9]{10}$/;
      if(!regexs.test(this.phoneNum)){
         Toast({
          message: '手机号不正确',
          className: 'coln'
        })
        return
      }
      if(!this.verifyNum){
        Toast({
          message: '短信验证码不能为空',
          className: 'coln'
        })
        return
      }
      if(!this.password){
        Toast({
          message: '密码不能为空',
          className: 'coln'
        })
        return
      }
      this.nowinxin()
      // if (this.uas.match(/MicroMessenger/i) == "micromessenger"){
      //  console.log("微信浏览器")
      // //  this.wixin ()
      // }else{
      //   console.log("不是微信浏览器")
      //   this.nowinxin()
      // }
   },
  //  微信授权
  //  wixin () {
  //    console.log(this.url)
  //    console.log(this.bizId)
  //    console.log(this.url + '/api/' + this.bizId + '/wechat/auth/login?activityUrl=' +encodeURIComponent(window.location.href))
  //    window.location.href = this.url + '/api/' + this.bizId + '/wechat/auth/login?activityUrl=' +encodeURIComponent(window.location.href)
  //   },
    // 不是微信浏览器
    nowinxin () {
      axios.post(this.GLOBAL.apiUrlNative + '/api/' + this.bizId +'/amoy/auth/register',
      {mobile:this.phoneNum,type:'register',scenario:'register',sms_code:this.verifyNum,invite_code:this.yaoqingma,
      password:this.password,re_password:this.password}
      ).then((ress) => {
        console.log(ress.data.code)
         if(ress.data.code == 0){
           console.log(23)
          //  this.$router.push({
          //     path: '/download1',
          //     query: {code: this.code, codeVersion: this.codeVersion}
          // })  
          this.goDownload()
        } else{
           Toast({
            message: ress.data.msg,
            className: 'coln'
          })
        }
      })
    },
    // 去下载页
    goDownload () {
      window.location.href = this.downloadUrl
    },
    deviceType () {
      let u = navigator.userAgent
      // android终端
      let isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1
      // ios终端
      let isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
      if (isiOS) {
        return 'ios'
      } else if (isAndroid) {
        return 'android'
      } else {
        return 'other'
      }
    },
    // 获取验证码
    getVerify () {
      var regexs = /^[1][0-9]{10}$/;
      if(!regexs.test(this.phoneNum)){
         Toast({
          message: '手机号不正确',
          className: 'coln'
        })
        return
      }
      axios.post(this.GLOBAL.apiUrlNative + '/api/' + this.bizId +'/amoy/auth/sms-verifycode',
        {mobile:this.phoneNum,type:'register'}).then((res) => {
          if (res.data.code == '0') {
            this.timeshow = false
            this.timeFn()
          } else {
            Toast ({
              message: res.data.msg,
              className: 'coln'
            })
          }
      })
    },
    getVerifyss () {
      Toast({
          message: '  请不要重复点击！',
          className: 'coln'
        })
    },
    timeFn () {
      var tt =  setInterval(()=>{
        this.time--
        console.log(this.time)
        if (this.time <=0) {
          clearInterval(tt)
          this.timeshow = true
        }  
      }, 1000)
    }
  }
}
</script>
<style lang="less" scoped>
  html,body{
    min-height: 100vh;
    width: 100vw;
  }
  #app{
    min-height: 100vh;
    width: 100vw;
  }
    .zhuce_box{
      min-height: 100vh;
      width: 100vw;
      background: url(../assets/zhuce/miaobg.png) 0 0 no-repeat;
      background-size: 100% 100%;
      
        .title {
            width: 100%;
            height: 0.88rem;
            background: #fff;
            display: flex;
            align-items: center;
            justify-content: center;
            border-bottom: .01rem rgba(218,218,218,1) solid;
            .title_text {
                font-size: 0.34rem;
                font-weight: bold;
                color: rgba(47, 47, 47, 1);
                line-height: 0.36rem;
                white-space: nowrap;
            }
        }
        .zhuce_core{
          overflow: hidden;
          position: fixed;
          bottom: .5rem;
          width: 100%;
          >div:nth-child(1){
            font-size: .42rem;
            font-weight:bold;
            color:#ffffff;
            margin-bottom: .2rem;
            text-align: center;
          }
          .zhuce-core-box{
            background: url(../assets/zhuce/miaobg1.png) 0 0 no-repeat;
            background-size: 100% 100%;
            margin: 0 10%;
            overflow: hidden;
           >div:nth-child(1){
              text-align: center;
              width: 100%;
              height: 1.7rem;
              >img{
                width: 4.36rem;
                height: .39rem;
              }
           }
          }
          .phone_box{
            padding: 0 .5rem;
            .phone_box_t {
              width: 100%;
              height: .88rem;
              display: flex;
              align-items: center;
              border-bottom: .01rem solid rgba(218,218,218,1);
              >div {
                width: .7rem;
                height: .88rem;
                display: flex;
                justify-content: center;
                align-items: center;
                img{
                  width: .28rem;
                  height: auto;
                }
              }
              input {
                height: .8rem;
                font-size: .28rem;
                font-weight:400;
                color:rgba(182,182,182,1) !important;
                border:none;
                outline: none;
              }
            }
            .phone_box_c{
              display: flex;
              justify-content: space-between;
              margin: .5rem 0;
              .phone_box_t {
              width: 3.3rem;
              height: .88rem;
              display: flex;
              align-items: center;
              border-bottom: .01rem solid rgba(218,218,218,1);
              >div {
                width: .7rem;
                height: .88rem;
                display: flex;
                justify-content: center;
                align-items: center;
                img{
                  width: .28rem;
                  height: auto;
                }
              }
              input {
                width: 100%;
                height: .8rem;
                font-size: .28rem;
                font-weight:400;
                color:rgba(182,182,182,1) !important;
                border:none;
                outline: none;
              }
            }
              .phone_box_r{
                width: 1.65rem;
                height: .88rem;
                background: rgba(255,116,23,1);
                font-size: .26rem;
                line-height: .88rem;
                text-align: center;
                color: #ffffff;
                border-radius: .1rem;
                // margin-top: .28rem;
              }
              .phone_box_r.phone_box_n{
                border: .02rem solid rgba(153,153,153,1);
                background: rgba(153,153,153,1);
                color: #ffffff;
              }
            }
          }
        }
        .zhuce{
          width: 100%;
          display: flex;
          justify-content: center;
          // position: fixed;
          // bottom: 1.8rem;
          margin: .8rem 0;
          >div{
            width: 4.9rem;
            height: .9rem;
            background:rgba(255,116,23,1);
            font-size: .36rem;
            font-weight:500;
            color:rgba(255,255,255,1);
            line-height:.9rem;
            text-align: center;
            border-radius: .1rem;
          }
        }
    }

</style>



// WEBPACK FOOTER //
// src/components/miaoshengZhuce.vue